import { render, staticRenderFns } from "./ChipComponent.vue?vue&type=template&id=4e338fe5&lang=pug"
import script from "./ChipComponent.vue?vue&type=script&lang=js"
export * from "./ChipComponent.vue?vue&type=script&lang=js"
import style0 from "./ChipComponent.vue?vue&type=style&index=0&id=4e338fe5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports